import EditIcon from "@mui/icons-material/Edit";
import { Typography } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import TextField from "@mui/material/TextField";
import React from "react";
import { withTranslation } from "react-i18next";
import { NAMESPACES } from "@/i18n/constants";

import { withSnackbar } from "@/hooks/use-snackbar/use-snackbar";
import InfoCard from "@/features/cards/deprecated/info-cards/info-card";

const AOI_CARD_CONTENT_HEIGHT = 36;
class AreaOfInterestInfoCardTemp extends InfoCard {
    constructor(props) {
        super(props);
        this.DeviceName = this.Target.name;
        this.title = (
            <TextField
                style={{
                    width: "100%",
                }}
                defaultValue={this.Target.name}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onChange={(e) => {
                    const a = { ...e };
                    this.Target.name = a.target.value;
                    this.triggerOnChange(a.target.value);
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position={"end"}>
                            <EditIcon />
                        </InputAdornment>
                    ),
                }}
            />
        );
        this.ContentComponent = AreaOfInterestInfoCardBody;
    }

    minHeightExpression = () => `${AOI_CARD_CONTENT_HEIGHT}px`; // Manually override the minHeight based on manual measurement

    // Provide a scaled maxHeight to be used as the maxHeight for the bounce animation (see bounceLoadInfoCard)
    maxHeightExpression = () => `${AOI_CARD_CONTENT_HEIGHT * 3}px`;

    componentDidMount() {
        super.componentDidMount();
    }

    k = 0;

    triggerOnChange(newName) {
        this.k++;
        const temp = this.k;
        setTimeout(() => {
            if (temp === this.k) {
                const { t } = this.props;
                try {
                    this.Target.edit({
                        name: newName,
                    })
                        .then(() => {
                            this.props.enqueueSuccessSnackbar(t("saved"));
                        })
                        .catch((e) => {
                            console.warn(e);
                            this.props.enqueueErrorSnackbar(t("save-failed"));
                        });
                } catch (e) {
                    console.warn(e);
                    this.props.enqueueErrorSnackbar(t("save-failed"));
                }
            }
        }, 3000);
    }
}
export const AreaOfInterestInfoCard = withTranslation(NAMESPACES.FEATURES.CARDS, {
    keyPrefix: "deprecated.info-cards.area-of-interest-info-card",
})(withSnackbar(AreaOfInterestInfoCardTemp));

export function AreaOfInterestInfoCardBody({ Target }) {
    return (
        <List
            className={"InfoPane_detailList"}
            key={`ActuallyGenned_InfoCard--${Target.UID}`}
            style={{
                paddingTop: "8px", // Override default paddingTop from class .InfoPane_detailList
            }}
        >
            <ListItem sx={{ paddingY: "10px" }}>
                <Typography variant={"caption"} style={{ color: "#757575" }}>
                    {`ID: ${Target.id}`}
                </Typography>
            </ListItem>
        </List>
    );
}
